import { HTTP } from '../../http-common'

export default {
  state: {
    loadedOwnships: []
  },
  getters: {
    loadedOwnships (state) {
      return state.loadedOwnships
    }
  },
  mutations: {
    setLoadedOwnships (state, payload) {
      state.loadedOwnships = payload
    },
    createOwnship (state, payload) {
      state.loadedOwnships.push(payload)
    },
    updateOwnship (state, payload) {
      state.loadedOwnships = state.loadedOwnships.map(ownship => ownship.id === payload.id ? payload : ownship)
    },
    removeOwnship (state, id) {
      state.loadedOwnships = state.loadedOwnships.filter(ownship => {
        return ownship.id !== id
      })
    },
    clearLoadedOwnships (state) {
      state.loadedOwnships = []
    }
  },
  actions: {
    loadOwnships ({ commit }) {
      commit('clearError')
      commit('setLoading', true)
      commit('setLoadedOwnships', [])
      console.log('loadOwnships')
      return new Promise((resolve, reject) => {
        HTTP.get('ownship.json')
          .then(result => {
            console.log(result.data)
            commit('setLoadedOwnships', result.data.results)
            resolve(result.data)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    createOwnship ({ commit, getters }, payload) {
      console.log('createOwnship')
      commit('clearError')
      commit('setLoading', true)
      const newOwnship = {
        description: payload.description,
        country: {
          id: payload.country.id
        },
        state: {
          id: payload.state.id
        },
        city: {
          id: payload.city.id
        },
        owner: {
          id: payload.owner.id
        },
        internet_connection: payload.internet_connection,
        latitude: payload.latitude,
        longitude: payload.longitude,
        responsible_contact: payload.responsible_contact,
        responsible_phone: payload.responsible_phone,
        responsible_email: payload.responsible_email
      }
      console.log('newOwnship', newOwnship)
      return new Promise((resolve, reject) => {
        HTTP.post('ownship.json/', newOwnship)
          .then(result => {
            console.log(result)
            commit('createOwnship', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    updateOwnship ({ commit, getters }, payload) {
      console.log('updateOwnship')
      commit('clearError')
      commit('setLoading', true)
      const ownship = {
        description: payload.description,
        country: {
          id: payload.country.id
        },
        state: {
          id: payload.state.id
        },
        city: {
          id: payload.city.id
        },
        owner: {
          id: payload.owner.id
        },
        internet_connection: payload.internet_connection,
        latitude: payload.latitude,
        longitude: payload.longitude,
        responsible_contact: payload.responsible_contact,
        responsible_phone: payload.responsible_phone,
        responsible_email: payload.responsible_email
      }
      console.log('ownship', ownship)
      return new Promise((resolve, reject) => {
        HTTP.patch(`ownship.json/${payload.id}/`, ownship)
          .then(result => {
            console.log(result)
            commit('updateOwnship', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    removeOwnship ({ commit }, payload) {
      console.log('removeOwnship')
      commit('clearError')
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        HTTP.delete(`ownship.json/${payload}`)
          .then(result => {
            console.log('result', result)
            commit('removeOwnship', payload)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    clearLoadedOwnships ({ commit }) {
      commit('clearLoadedOwnships')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/ownship/index.js